
// 高德地图 key 区分开发、线上环境
const AMAP_CONFIG = {
  // 开发环境
  'development': { key: 'c0cea128fbf8043cbb3f54fcbb202208', serviceHost: 'https://ie-lcn.lanhanba.net/_AMapService/dev' },
  // 线上环境
  'production': { key: '1bdbe7857a98a2c5e6fcaa2ebd0a96f0', serviceHost: 'https://lcn.locxx.com/_AMapService' },
};

const curAmapConfig = process.env.NODE_ENV === 'development' ? AMAP_CONFIG['development'] : AMAP_CONFIG['production'];
export const libsMap: { [key: string]: any } = {
  // js
  // echarts: 'https://staticres.linhuiba.com/libs/echarts/5.1.2/echarts-flow.min.js',
  amap: `https://webapi.amap.com/maps?v=2.0&key=${curAmapConfig.key}&callback=amapInit&plugin=AMap.CitySearch,AMap.Scale,AMap.OverView,AMap.ToolBar,AMap.Autocomplete,AMap.PlaceSearch,AMap.CircleEditor,AMap.PolyEditor,AMap.Geocoder,AMap.Geolocation,AMap.ToolBar,AMap.IndoorMap,AMap.DistrictSearch,AMap.Polygon`, // 高德地图
  jsScreenShot: 'https://staticres.linhuiba.com/libs/js-web-screen-shot/1.9.8-rc.3/screenShotPlugin.umd.js', // 截图绘制
  amapUI: 'https://webapi.amap.com/ui/1.1/main.js', // 高德ui库
};

// 高德地图自2021年12月02日升级，升级之后所申请的 key 必须配备安全密钥 jscode 一起使用
// 具体见 src/common/utils/get-script.ts 内的 window._AMapSecurityConfig
// 安全秘钥代理地址
export const serviceHost = curAmapConfig.serviceHost;
export const aMapKey = curAmapConfig.key;
